import React, { useState, useEffect } from "react";
import DashboardApi from "../../Api/DashboardApi";

const TopSellingProductsTable = ({ filter }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTopProducts();
    }, [filter]);

    const fetchTopProducts = async () => {
        setLoading(true);
        try {
            const res = await DashboardApi.getTopSellingProducts(filter);
            if (res.status && res.response.data) {
                setProducts(res.response.data);
            } else {
                setProducts([]);
            }
        } catch (error) {
            console.error("Error fetching top selling products:", error);
        } finally {
            setLoading(false);
        }
    };

    const renderAttributes = (combination) => {
        if (!combination || !Array.isArray(combination)) return "N/A";
        return combination.map(c => c.value).join(", ");
    };

    return (
        <div className="card radius-12 border-0 shadow-sm">
            <div className="card-header border-bottom bg-base py-16 px-24">
                <h6 className="text-lg fw-semibold mb-0">Top 10 Selling Products - {filter}</h6>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive">
                    <table className="table margin-0-important mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th className="px-24">Product</th>
                                <th>Attributes</th>
                                <th>Quantity Sold</th>
                                <th>Revenue</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                Array.from({ length: 5 }).map((_, i) => (
                                    <tr key={i}>
                                        <td className="px-24"><div className="skeleton-line w-75 bg-light py-10 radius-4"></div></td>
                                        <td><div className="skeleton-line w-50 bg-light py-10 radius-4"></div></td>
                                        <td><div className="skeleton-line w-25 bg-light py-10 radius-4"></div></td>
                                        <td><div className="skeleton-line w-25 bg-light py-10 radius-4"></div></td>
                                    </tr>
                                ))
                            ) : products.length > 0 ? products.map((product, index) => (
                                <tr key={index}>
                                    <td className="px-24">
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="fw-semibold text-secondary-light">{product.productName}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="text-muted small">{renderAttributes(product.combination)}</span>
                                    </td>
                                    <td>{product.quantitySold}</td>
                                    <td>₹{product.revenue.toLocaleString("en-IN")}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="4" className="text-center py-4 text-secondary-light">No data available for this period</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};


export default TopSellingProductsTable;
